export default __webpack_public_path__ + "static/media/annealing-icon-dark.b900e667.svg";